<script>
    import ClientData from "./ClientData";
    import SwitchOffTimes from "../switchOffTimes/switch-off-times.vue";

    export default {
        name: "client-dialog-switch-off-times-tab",
        components: {SwitchOffTimes},
        props: {
            clientData: ClientData,
            required: true
        },
        computed: {
            switchOffTimesDisabled() {
                return Lang.langGet("The Switch-Off Times are deactivated for the current project.");
            }
        }
    }
</script>

<template>
    <div v-if="clientData.switchOffTimesActive">
        <switch-off-times
            :data="clientData.switchOffTimes"
            class="pa-4 pt-0"
            enableConfiguredByProject
            @input="$emit('input', $event)"
            popupUsedInModal
        />
    </div>
    <div v-else>
        {{switchOffTimesDisabled}}
    </div>
</template>
